import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=15d4fb76&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=15d4fb76&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d4fb76')) {
      api.createRecord('15d4fb76', component.options)
    } else {
      api.reload('15d4fb76', component.options)
    }
    module.hot.accept("./shop.vue?vue&type=template&id=15d4fb76&", function () {
      api.rerender('15d4fb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/shop.vue"
export default component.exports